/**
 * Giới hạn thời gian chờ (ms) cho các request TẠO export job.
 *
 * Vì sao cần: 2 axios factory dùng cho API export (`packingRequest`, `makeApiRequest`)
 * không cấu hình `timeout` → axios chờ vô hạn. Khi exporter-service tải cao, request
 * treo hàng phút trong khi job đã được tạo ở server, user tưởng hỏng nên bấm lại
 * nhiều lần → nhiều export job trùng nhau.
 *
 * Vì sao KHÔNG set ở factory: 2 factory đó dùng chung cho hàng chục API khác
 * (danh sách, thống kê, report nặng) vốn dựa vào việc không có timeout để chạy xong.
 * Set ở factory sẽ làm các màn hình đang hoạt động bình thường báo lỗi trong giờ cao điểm.
 * Vì vậy chỉ override `timeout` theo TỪNG request export.
 *
 * Lưu ý: timeout của axios chỉ hủy phía client — job ở exporter-service vẫn tiếp tục chạy.
 * Đó là lý do khi hết hạn chờ, `runExportJob` thông báo "job có thể đã được tạo" và hướng
 * user sang màn Danh sách Job, chứ không báo "thất bại, thử lại".
 */
export const EXPORT_JOB_TIMEOUT = 60000
